import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Payment, Transaction } from './../../models';
import { PaymentMethodsService } from './../../services/payment-methods.service';
import { AlertService } from './../../services/alert.service';
import { TokenServiceService } from '../../services/token-service.service';
import { COMMERCIAL_NETWORKS } from '../../core/constants/CommercialNetwork';
import { clone } from 'lodash';
import CREDIT_CARDS, { AMEX, CODENSA, DINERS_CLUB, UNION_PAY } from '../../core/constants/credit-cards.constants';
import { WALLET_VALIDATIONS } from '../../core/constants/Errors';
import { PARAMS_TO_ORDER_LIST } from 'src/app/core/constants/AlertMessages';
import { environment } from '../../../environments/environment';
import { ALERT_ICON_CONSTANTS, FLAGS_NAME, GENERAL_CONSTANTS, PCOL_TRANSACTION_KEYS, PCO_NETWORK_CODES } from '../../core/constants/General-constants';
import { BANK_IDS, ORDER_METHODS } from '../../core/constants/payMethods-cr';
import { BANK_GU_IDS, GU_ORDER_METHODS } from 'src/app/core/constants/payMethods-gu';
import { PayvalidaFeatureFlagService } from '../../services/payvalida-feature-flag.service';
import { SweetAlertIcon } from 'sweetalert2';
import { ASSETS_CONSTANTS } from 'src/app/core/constants/Assets-constants';

@Component({
    selector: 'app-pay-methods',
    templateUrl: './pay-methods.component.html',
    styleUrls: ['./pay-methods.component.scss'],
})

// TODO: TECHNICAL DEBT 28476 https://dev.azure.com/payvalida/payValida/_workitems/edit/28476
export class PayMethodsComponent implements OnInit {
    @Output() cash = new EventEmitter();
    @Output() cc = new EventEmitter();
    @Output() pse = new EventEmitter();
    @Output() deposit = new EventEmitter();
    @Output() transfer = new EventEmitter();
    @Output() wallet = new EventEmitter();
    @Output() transferCRC = new EventEmitter();
    @Output() bnpl = new EventEmitter();
    @Output() qrEmitter = new EventEmitter();
    @Output() subMenuCREmitter = new EventEmitter();
    @Output() subMenuGUEmitter = new EventEmitter();
    @Output() peruMethods = new EventEmitter();
    @Output() splitPayment = new EventEmitter();
    @Output() sinpePayment = new EventEmitter();
    @Output() cdcEmitter = new EventEmitter();
    @Output() puntosColombiaPayment = new EventEmitter();
    @Output() listPaymentsEmitter = new EventEmitter();
    @Output() ccNewFlow = new EventEmitter();
    @Output() preloadEmbebedTcForm = new EventEmitter();
    @Output() preloadEmbebedApiPayInForm = new EventEmitter();
    @Output() apiPayInFormPayment = new EventEmitter();
    @Input() isCreditCardUnique = false;
    @Input() flagRedeban: boolean;

    title: string;
    subtitle: string;
    token: string;
    creditCards: Payment[] = [];
    transfers: Payment[] = [];
    deposits: Payment[] = [];
    networks: Payment[] = [];
    wallets: Payment[] = [];
    sortedWalletList: Payment[] = [];
    transfersCRC: Payment[] = [];
    bnplMethods: Payment[] = [];
    bancolombiaMethods: Payment[] = [];
    splitMethods: Payment[] = [];
    sinpeMethodsList: Payment[] = [];
    logoBNCR = environment.logo_bn_cr;
    logoBCR = environment.logo_bcr;
    logoBam = environment.logo_bam_gu;
    logoBI = environment.logo_bi_gu;
    logoLafise = environment.logoLafiseBank;
    logoPuntosCol = ASSETS_CONSTANTS.PUNTOS_COLOMBIA_LOGO;
    subMenuBNCR: Payment[] = [];
    subMenuBCR: Payment[] = [];
    subMenuBAM: Payment[] = [];
    subMenuBI: Payment[] = [];
    subMenuLafise: Payment[] = [];
    checkoutGuideDocLink = environment.urlCheckoutGuide;
    subMenuGuFlag: boolean = false;
    lafiseBanksPaymentMethodFF: boolean = false;
    enableCheckoutEmbebedTcFormFF: boolean = false;
    enableCheckoutEmbebedApiPayInFormFF: boolean = false;
    puntosColombiaList: Payment[] = [];
    apiPayInList: Payment[] = [];
    ptosColFF: boolean = false;
    pColTransaction: any = {};
    moviiAmexFranchiseFF: boolean = false;
    niubizAmexFranchiseFF: boolean = false;
    franchises: String[] = []

    loading: boolean;
    numCol = {
        transfers: 3,
        deposit: 3,
        cash: 3,
        wallet: 3,
    };
    merchantId: string;
    transaction: Transaction;
    msgValidation = WALLET_VALIDATIONS;
    showNewCRMessageCash = false;
    PERU_RED = { scotiabank: 1154, bbva: 370 };

    constructor(
        private readonly paymentMethodsService: PaymentMethodsService,
        private readonly alertService: AlertService,
        private readonly tokenServiceService: TokenServiceService,
        private featureFlagService: PayvalidaFeatureFlagService
    ) { }

    async ngOnInit() {
        this.loading = true;
        this.token = this.tokenServiceService.getToken();
        this.transaction = this.tokenServiceService.getAndDecodeToken();
        this.pColTransaction = JSON.parse(localStorage.getItem(`${PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_OBJECT_KEY}-${this.transaction.ORDER_REFERENCE}`)) ?? '';

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.LAFISE_BANKS_PAYMENT_METHOD, FLAGS_NAME.LAFISE_BANKS_PAYMENT_METHOD).subscribe((response: boolean) => {
            this.lafiseBanksPaymentMethodFF = response;
        });

        this.featureFlagService.getFeatureFlagValue(this.transaction.MERCHANT_ID, FLAGS_NAME.ENABLE_CHECKOUT_EMBEBED_TC_FORM_FF).subscribe((response: boolean) => {
            this.enableCheckoutEmbebedTcFormFF = response;
            this.preloadEmbebedTcForm.emit(response);
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.ENABLE_CHECKOUT_EMBEBED_API_PAY_IN_FORM_FF, FLAGS_NAME.ENABLE_CHECKOUT_EMBEBED_API_PAY_IN_FORM_FF).subscribe((response: boolean) => {
          this.enableCheckoutEmbebedApiPayInFormFF = response;
          this.preloadEmbebedApiPayInForm.emit(response);
      });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.SUB_MENU_GU_PARAMETER, FLAGS_NAME.SUB_MENU_GU_FLAG).subscribe((response: boolean) => {
            this.subMenuGuFlag = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.PCO_PAY_METHOD_FF, FLAGS_NAME.PCO_PAY_METHOD_FF).subscribe((response: boolean) => {
            this.ptosColFF = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.MOVII_AMEX_FRANCHISE_FF, FLAGS_NAME.MOVII_AMEX_FRANCHISE_FF).subscribe((response: boolean) => {
            this.moviiAmexFranchiseFF = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.NIUBIZ_AMEX_FRANCHISE_FF, FLAGS_NAME.NIUBIZ_AMEX_FRANCHISE_FF).subscribe((response: boolean) => {
            this.niubizAmexFranchiseFF = response;
        });

        this.paymentMethodsService.paymentMethods(this.token).subscribe(
            async (result: any) => {
                this.loading = false;
                this.paymentMethodsService.visibleReturnPayMethods.emit(!result.DATA.noReturnToMethods);
                const listPayments = result.DATA.paymentMethods ? result.DATA.paymentMethods : [];
                this.listPaymentsEmitter.emit(listPayments);
                for (const key of listPayments) {
                    // TODO: (https://dev.azure.com/payvalida/payValida/_workitems/edit/35167): Refactor switch de categorias en componente pay-methods - checkout
                    switch (key.category) {
                        case '1':
                            this.deposits.push(key);
                            break;

                        case '2':
                            if (key.code === BANK_GU_IDS.BAM_TRANSFER && this.subMenuGuFlag) {
                                this.subMenuBAM.push(key);
                            } else if (key.code === BANK_GU_IDS.BI_TRANSFER && this.subMenuGuFlag) {
                                this.subMenuBI.push(key);
                            } else {
                                this.transfers.push(key);
                            }
                            break;

                        case '3':
                            if (key.code === BANK_IDS.BNCR_PAY_WEB) {
                                this.subMenuBNCR.push(key);
                                let keyAux = clone(key);
                                keyAux.code = BANK_IDS.BNCR_CASH;
                                this.subMenuBNCR.push(keyAux);
                            } else if (key.code === BANK_GU_IDS.BAM_CASH && this.subMenuGuFlag) {
                                this.subMenuBAM.push(key);
                                let keyAux = clone(key);
                                keyAux.code = BANK_GU_IDS.BAM_PAY_WEB;
                                this.subMenuBAM.push(keyAux);
                            } else {
                                this.networks.push(key);
                            }
                            break;

                        case '4':
                            const creditCards = CREDIT_CARDS.map((card) => {
                                return {
                                    ...key,
                                    name: card.name,
                                    logo: card.logo,
                                    franchise: card.id,
                                };
                            });

                            const moviiFFfranchises = this.moviiAmexFranchiseFF ? [CODENSA.id, DINERS_CLUB.id, UNION_PAY.id] : [CODENSA.id, DINERS_CLUB.id, UNION_PAY.id, AMEX.id];
                            const niubizFilteredFranchises = this.niubizAmexFranchiseFF ? [CODENSA.id, AMEX.id] : [CODENSA.id];

                            const franchiseFilters = {
                                [COMMERCIAL_NETWORKS.REDEBAN]: [CODENSA.id, DINERS_CLUB.id, UNION_PAY.id],
                                [COMMERCIAL_NETWORKS.CREDIBANCO]: [CODENSA.id, DINERS_CLUB.id, UNION_PAY.id],
                                [COMMERCIAL_NETWORKS.CREDIBANCO_USD]: [CODENSA.id, DINERS_CLUB.id, UNION_PAY.id],
                                [COMMERCIAL_NETWORKS.COOPENAE]: [CODENSA.id, AMEX.id, DINERS_CLUB.id, UNION_PAY.id],
                                [COMMERCIAL_NETWORKS.COOPENAE_USD]: [CODENSA.id, AMEX.id, DINERS_CLUB.id, UNION_PAY.id],
                                [COMMERCIAL_NETWORKS.PAYMENTEZ_ECU]: [CODENSA.id, AMEX.id, DINERS_CLUB.id, UNION_PAY.id],
                                [COMMERCIAL_NETWORKS.LAFISE]: [CODENSA.id, DINERS_CLUB.id, UNION_PAY.id],
                                [COMMERCIAL_NETWORKS.LAFISE_USD]: [CODENSA.id, DINERS_CLUB.id, UNION_PAY.id],
                                [COMMERCIAL_NETWORKS.NIUBIZ]: niubizFilteredFranchises,
                                [COMMERCIAL_NETWORKS.NIUBIZ_USD]: niubizFilteredFranchises,
                                [COMMERCIAL_NETWORKS.MOVII]: moviiFFfranchises,
                                default: [CODENSA.id],
                            };

                            const excludeFranchises = (cards: Payment[], franchisesToExclude) => cards.filter((card) => !franchisesToExclude.includes(card.franchise));
                            const franchisesToExclude = franchiseFilters[key.code] || franchiseFilters.default;
                            this.creditCards = excludeFranchises(creditCards, franchisesToExclude);

                            break;

                        case '5':
                            this.handleDeposits(key);
                            break;

                        case '6':
                            this.wallets.push(key);
                            break;

                        case '7':
                            if (this.isCR(key.code)) {
                                this.addSubMenusCR(key);
                            } else if (this.isGU(key.code) && this.subMenuGuFlag) {
                                this.addSubMenusGU(key);
                            } else {
                                this.transfersCRC.push(key);
                            }
                            break;

                        case '8':
                            this.bnplMethods.push(key);
                            break;

                        case '9':
                            this.bancolombiaMethods.push(key);
                            break;

                        case '12':
                            this.splitMethods.push(key);
                            break;

                        case '13':
                            this.sinpeMethodsList.push(key);
                            break;

                        case '15':
                            if (key.code === PCO_NETWORK_CODES.PCO_SPLIT_NETWORK_CODE) return;

                            if (this.pColTransaction.isPcolTransaction) return;

                            this.puntosColombiaList.push(key);
                            break;
                        case '16':
                          if (!environment.production) this.apiPayInList.push(key);
                          break;
                    }
                }

                this.validateNumColTrans();
                if (this.wallets.length > 1) {
                    this.orderWalletList();
                }

                switch (this.transaction.ORDER_METHOD) {
                    case ORDER_METHODS.BNCR:
                        this.subMenu(this.subMenuBNCR);
                        break;
                    case ORDER_METHODS.BCR:
                        this.subMenu(this.subMenuBCR);
                        break;
                    case GU_ORDER_METHODS.BAM:
                        this.subMenuGU(this.subMenuBAM);
                        break;
                    case GU_ORDER_METHODS.BI:
                        this.subMenuGU(this.subMenuBI);
                        break;
                    case ORDER_METHODS.LAFISE:
                        this.subMenu(this.subMenuLafise);
                }
            },
            (error) => {
                error = error?.error?.message != null ? error.error.message : GENERAL_CONSTANTS.GENERAL_ALERT;
                this.alertService.showAlert(error, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
            }
        );
    }

    /**
     * @description Function that sorts the list of available wallets alphabetically
     */
    orderWalletList() {
        this.sortedWalletList = this.wallets
            .filter((f) => f.name !== this.msgValidation.hiddenWallet)
            .sort((a: any, b: any) => {
                if (a[PARAMS_TO_ORDER_LIST.PRIORITY] > b[PARAMS_TO_ORDER_LIST.PRIORITY]) return -1;
                if (a[PARAMS_TO_ORDER_LIST.PRIORITY] < b[PARAMS_TO_ORDER_LIST.PRIORITY]) return 1;
                return 0;
            });
        this.wallets = this.sortedWalletList;
    }

    private validateNumColTrans() {
        if (this.transfers.length > 2) {
            this.numCol.transfers = 3;
        } else {
            this.numCol.transfers = this.transfers.length;
        }

        if (this.deposits.length > 2) {
            this.numCol.deposit = 3;
        } else {
            this.numCol.deposit = this.deposits.length;
        }

        if (this.networks.length > 2) {
            this.numCol.cash = 3;
        } else {
            this.numCol.cash = this.networks.length;
        }
        if (this.wallets.length > 2) {
            this.numCol.wallet = 3;
        } else {
            this.numCol.wallet = this.wallets.length;
        }
    }

    methods(payment: Payment) {
        if (payment.category == '5' && this.paymentMethodsService.validatePeruCommercialnet(payment.code)) {
            this.peruMethods.emit(payment);
            return;
        }

        switch (payment.category) {
            case '1':
                this.cash.emit(payment);
                break;
            case '2':
                this.transfer.emit(payment);
                break;
            case '3':
                this.cash.emit(payment);
                break;
            case '4':
                if (this.enableCheckoutEmbebedTcFormFF) {
                    this.ccNewFlow.emit(payment)

                    break;
                };

                this.cc.emit(payment);
                break;
            case '5':
                this.cash.emit(payment);
                break;
            case '6':
                this.wallet.emit(payment);
                break;
            case '7':
                this.transferCRC.emit(payment);
                break;
            case '8':
                this.bnpl.emit(payment);
                break;
            case '9':
                this.qrEmitter.emit(payment);
                break;
            case '12':
                this.splitPayment.emit(payment);
                break;
            case '13':
                this.sinpePayment.emit(payment);
                break;
            case '15':
                this.puntosColombiaPayment.emit(payment);
                break;
            case '16':
                this.apiPayInFormPayment.emit(payment);
                break;
            default:
                this.alertService.showAlertProblem();
                break;
        }
    }

    methodsByTemplete(payment: Payment) {
        switch (payment['template']) {
            case GENERAL_CONSTANTS.TEMPLATES.QR:
                this.qrEmitter.emit(payment);
                break;
            case GENERAL_CONSTANTS.TEMPLATES.CASH:
                this.cash.emit(payment);
                break;
            case GENERAL_CONSTANTS.TEMPLATES.CONSUMER_CREDIT:
                this.cdcEmitter.emit(payment);
                break;
            case GENERAL_CONSTANTS.TEMPLATES.BNPL_BANCOLOMBIA:
                this.bnpl.emit(payment);
                break;
            default:
                this.alertService.showAlertProblem();
                break;
        }
    }

    /// Get the logo of the TC payment method
    getTcLogo = () => environment.urlTcImage;

    /**
     * @description in charge of controlling which view the sub-menu directs to
     * @param payments user selected payment method information
     */
    subMenu(payments) {
        this.subMenuCREmitter.emit(payments);
    }

    /**
     * @description in charge of controlling which view the sub-menu of Guatemala directs to
     * @param payments user selected payment method information
     */
    subMenuGU(payments) {
        this.subMenuGUEmitter.emit(payments);
    }

    /**
     * @description controls the flow to the sub menu of the businesses in costa rica
     */
    addSubMenusCR(payment: Payment) {
        if (payment.code === BANK_IDS.BNCR_PAY_WEB || payment.code === BANK_IDS.BNCR_DEPOSIT || payment.code === BANK_IDS.BNCR_TRANSFER) {
            this.subMenuBNCR.push(payment);
        }

        if (payment.code === BANK_IDS.BCR_DEPOSIT || payment.code === BANK_IDS.BCR_TRANSFER) {
            this.subMenuBCR.push(payment);
        }

        if (payment.code === BANK_IDS.LAFISE_TRANSFER) {
            this.subMenuLafise.push(payment);
        }
    }

    /**
     * @description returns if the commercial code belongs to those of costa rica
     */
    isCR(code: number) {
        return (
            code === BANK_IDS.BNCR_PAY_WEB ||
            code === BANK_IDS.BNCR_DEPOSIT ||
            code === BANK_IDS.BNCR_TRANSFER ||
            code === BANK_IDS.BCR_DEPOSIT ||
            code === BANK_IDS.BCR_TRANSFER ||
            code === BANK_IDS.LAFISE_TRANSFER
        );
    }

    /**
     * @description controls the flow to the sub menu of the businesses in Guatemala
     */
    addSubMenusGU(payment: Payment) {
        if (payment.code === BANK_GU_IDS.BAM_PAY_WEB || payment.code === BANK_GU_IDS.BAM_DEPOSIT || payment.code === BANK_GU_IDS.BAM_TRANSFER) {
            this.subMenuBAM.push(payment);
        }
        if (payment.code === BANK_GU_IDS.BI_DEPOSIT_B || payment.code === BANK_GU_IDS.BI_DEPOSIT || payment.code === BANK_GU_IDS.BI_TRANSFER) {
            this.subMenuBI.push(payment);
        }
    }

    /**
     * @description returns if the commercial code belongs to those of Guatemala
     */
    isGU(code: number) {
        return (
            code === BANK_GU_IDS.BAM_PAY_WEB ||
            code === BANK_GU_IDS.BAM_DEPOSIT ||
            code === BANK_GU_IDS.BAM_TRANSFER ||
            code === BANK_GU_IDS.BI_DEPOSIT_B ||
            code === BANK_GU_IDS.BI_DEPOSIT ||
            code === BANK_GU_IDS.BI_TRANSFER
        );
    }

    /**
     * @description Depending the case, sets the key value into different arrays of deposit pay methods.
     */
    handleDeposits(key: any) {
        if (this.isCR(key.code)) {
            this.showNewCRMessageCash = true;

            return this.addSubMenusCR(key);
        }

        switch (key.code) {
            case BANK_GU_IDS.BAM_DEPOSIT:
                if (this.subMenuGuFlag) this.subMenuBAM.push(key);

                break;
            case BANK_GU_IDS.BI_DEPOSIT:
                if (this.subMenuGuFlag) {
                    this.subMenuBI.push(key);

                    let keyAux = clone(key);
                    keyAux.code = BANK_GU_IDS.BI_DEPOSIT_B;

                    this.subMenuBI.push(keyAux);
                }

                break;
            default:
                this.deposits.push(key);

                break;
        }
    }

    getFranchises() {
        return [...new Set(this.creditCards.map((card) => card.template))][0];
    }
}
